import { api } from '@/lib/api/client';
import type {
  AnalysisPolicy,
  JournalPage,
  JournalStats,
  Recommendation,
  TradingProfile,
} from './types';

/**
 * 단기매매 조회 API.
 *
 * 🔴 조회만 있다. 추천을 다시 만들거나 임계값을 바꾸는 엔드포인트가 없다.
 *   화면에서 다시 돌릴 수 있게 하면 결과가 마음에 안 들 때 기준을 낮춰
 *   재실행하고 싶어진다. (CLAUDE.md 1.3절, docs/impl/25-trading-api.md)
 */

/**
 * 최근 추천 목록.
 *
 * 0건은 오류가 아니라 200 + 빈 배열로 온다.
 * 실측상 절반이 넘는 날이 0건이라 그것이 기본 상태다.
 */
export async function fetchRecommendations(
  days: number,
  profile?: TradingProfile,
): Promise<Recommendation[]> {
  // profile 을 빼면 전체다. undefined 는 client 가 쿼리에서 지운다.
  return api.get<Recommendation[]>('/trading/recommendations', { days, profile });
}

export async function fetchRecommendation(id: number): Promise<Recommendation> {
  return api.get<Recommendation>(`/trading/recommendations/${id}`);
}

export async function fetchJournal(
  page: number,
  size: number,
  profile?: TradingProfile,
): Promise<JournalPage> {
  return api.get<JournalPage>('/trading/journal', { page, size, profile });
}

export async function fetchJournalStats(profile?: TradingProfile): Promise<JournalStats> {
  // 🔴 프로필을 섞은 승률은 뜻이 흐려진다. 목표 배수가 다르기 때문이다 (17단계)
  return api.get<JournalStats>('/trading/journal/stats', { profile });
}

/** AI 분석 기준. (3.12) */
export async function fetchAnalysisPolicy(): Promise<AnalysisPolicy> {
  return api.get<AnalysisPolicy>('/trading/analysis-policy');
}
